<div class="chat-image-viewer d-flex flex-column">
  <div class="chat-image-viewer__bar d-flex align-items-center gap-2 px-3 py-2">
    <span class="chat-image-viewer__name text-truncate flex-grow-1">{{ current.name }}</span>

    <button
      type="button"
      class="chat-image-viewer__btn"
      (click)="zoomOut()"
      [disabled]="!canZoomOut"
      [matTooltip]="'chat.imageViewer.zoomOut' | translate"
      [attr.aria-label]="'chat.imageViewer.zoomOut' | translate"
    >
      <i class="ri-zoom-out-line" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      class="chat-image-viewer__btn chat-image-viewer__zoom"
      (click)="resetZoom()"
      [disabled]="!canZoomOut"
      [matTooltip]="'chat.imageViewer.zoomReset' | translate"
      [attr.aria-label]="'chat.imageViewer.zoomReset' | translate"
    >
      {{ zoomLabel }}
    </button>
    <button
      type="button"
      class="chat-image-viewer__btn"
      (click)="zoomIn()"
      [disabled]="!canZoomIn"
      [matTooltip]="'chat.imageViewer.zoomIn' | translate"
      [attr.aria-label]="'chat.imageViewer.zoomIn' | translate"
    >
      <i class="ri-zoom-in-line" aria-hidden="true"></i>
    </button>
    <!-- Same download link as the file card and the audio player: browsers ignore
         `download` across origins, so a Firebase file opens in a new tab instead. -->
    <a
      class="chat-image-viewer__btn"
      [href]="current.url"
      target="_blank"
      rel="noopener noreferrer"
      download
      [attr.download]="current.name || null"
      [matTooltip]="'chat.imageViewer.download' | translate"
      [attr.aria-label]="'chat.imageViewer.download' | translate"
    >
      <i class="ri-download-2-line" aria-hidden="true"></i>
    </a>
    <button
      type="button"
      class="chat-image-viewer__btn"
      (click)="close()"
      [matTooltip]="'chat.imageViewer.close' | translate"
      [attr.aria-label]="'chat.imageViewer.close' | translate"
    >
      <i class="ri-close-line" aria-hidden="true"></i>
    </button>
  </div>

  <!-- The stage is "outside": pressing and releasing on it closes; the image toggles the zoom. -->
  <div
    #stage
    class="chat-image-viewer__stage flex-grow-1"
    (pointerdown)="onStagePointerDown($event)"
    (click)="onStageClick($event)"
  >
    @if (loading) {
      <div class="chat-image-viewer__state" role="status">
        <span class="spinner-border" aria-hidden="true"></span>
        <span class="visually-hidden">{{ 'chat.imageViewer.loading' | translate }}</span>
      </div>
    } @else if (failed) {
      <div class="chat-image-viewer__state" role="alert">
        <i class="ri-image-2-line font-24" aria-hidden="true"></i>
        <span>{{ 'chat.imageViewer.error' | translate }}</span>
      </div>
    }
    <img
      class="chat-image-viewer__image"
      [class.invisible]="loading || failed"
      [class.is-zoomed]="zoomStep > 0"
      [src]="current.url"
      [alt]="current.name || ''"
      [style.width.px]="width"
      [style.height.px]="height"
      draggable="false"
      (load)="onLoad($event)"
      (error)="onError()"
      (click)="toggleZoom(); $event.stopPropagation()"
    />
  </div>

  @if (images.length > 1) {
    <button
      type="button"
      class="chat-image-viewer__nav chat-image-viewer__nav--previous"
      (click)="previous()"
      [disabled]="!hasPrevious"
      [attr.aria-label]="'chat.imageViewer.previous' | translate"
    >
      <i class="ri-arrow-left-s-line" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      class="chat-image-viewer__nav chat-image-viewer__nav--next"
      (click)="next()"
      [disabled]="!hasNext"
      [attr.aria-label]="'chat.imageViewer.next' | translate"
    >
      <i class="ri-arrow-right-s-line" aria-hidden="true"></i>
    </button>
    <div class="chat-image-viewer__counter" aria-live="polite">
      {{ 'chat.imageViewer.counter' | translate: { current: index + 1, total: images.length } }}
    </div>
  }
</div>
